<template>
    <div>
        <div v-if="logLine.subject_type === 'reminders'" style="border-top: 1px solid #e1e0e0; padding: 10px 0">
            <log-line-footer :log-line="logLine"></log-line-footer>
        </div>
    </div>
</template>

<script>
    import LogLineFooter from './LogLineFooter'

    export default {
        components: {LogLineFooter},

        props: {logLine: {}}
    }
</script>
